import { PaletteUtils } from './paletteUtils';

const FIND_SYMBOL = 'X';
const FINAL_SYMBOL = '*';
const BLOCK_DIGITS_COUNT = 4;
const MASK_SYMBOL = '∙';

export const formatAmount = (amount: number | undefined, currency?: string) => {
  if (amount === null || typeof amount === 'undefined') return amount;
  const c = currency ? currency + ' ' : '';
  const absAmount = amount >= 0 ? amount : -amount;
  const d = Math.floor(absAmount);
  const arr = Array.from(d.toString())
    .reverse()
    .join('')
    .match(/\d{1,3}/g);
  const n = arr ? arr.join(',').split('').reverse().join('') : '';
  const sign = amount >= 0 ? '' : '-';
  const p = Math.round((absAmount - d) * 100);
  return `${c}${sign}${n}.${p < 10 ? '0' : ''}${p}`;
};

export const maskNumber = (value?: string | null, mask: string = MASK_SYMBOL) => {
  if (!value) return null;
  return value.replace(/\D/, mask);
};

export const maskNumberShort = (value?: string | null, mask: string = MASK_SYMBOL) => {
  if (!value) return null;
  const parts = value.split(/\D/g);
  return [mask, mask, mask, mask].join('') + ' ' + parts[parts.length - 1];
};

export const maskNumberUltra = (value?: string | null, mask: string = MASK_SYMBOL) => {
  if (!value) return null;
  return mask + ' ' + value.slice(-4);
};

export class FormatUtils {
  static toPhoneFormat = (phoneAreaCode: string, phoneNumber: string) => {
    return `+${phoneAreaCode}-${phoneNumber}`;
  };
  static toSliceNumber = (stringNumber: string, countSymbols: number = 8) => {
    if (!stringNumber) return '';
    const resultString = stringNumber
      .split('')
      .reduce<string[][]>((resultArray: string[][], item, index) => {
        const chunkIndex = Math.floor(index / BLOCK_DIGITS_COUNT);

        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
      }, [])
      .map((ch) => ch.join(''))
      .join(' ');
    const replacedString = resultString.replaceAll(FIND_SYMBOL, FINAL_SYMBOL);
    const countSpaces = Math.round(countSymbols / BLOCK_DIGITS_COUNT) - 1;
    return replacedString.slice(-(countSymbols + countSpaces));
  };

  static toMoneyFormat = (amount: number, decimalCount = 2, decimal = '.', thousands = ',') => {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substring(0, j) + thousands : '') +
      i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - parseInt(i))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  };

  static formatAccountNumber = (accountNumber: string) => `*${accountNumber.slice(-4)}`;

  static splitCamelCase = (value: string) => {
    const camelCase = value.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');
    return camelCase.map((item) => item.charAt(0).toUpperCase() + item.slice(1)).join(' ');
  };

  static transactionTypeTransformation = (value: string) =>
    PaletteUtils.isVcfcPalette && value.includes('Insignia') ? value.replace('Insignia', 'VCFC ') : value;

  static capitalize = (text: string) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
}
